// TODO: alcuni endpoint di "Task ID2" usati in questo hook danno cors error in particolare quelli per il download del tamplate
// Finché non risponde correttamente, il flusso "Carica tramite CSV" non funziona.
import useSWRMutation from "swr/mutation";
import { ServicesURL, downloadFile, uploadFile } from "@utils/utilsApi";
import { axiosInstance } from "src/services/config";

export interface EditionCsvUploadResponse {
  totalProcessed?: number;
  successfulEnrollments?: number;
  failedEnrollments?: number;
  uploadBatchId?: string;
  errors?: any[];
  warnings?: string[];
  message?: string;
}

export interface EditionCsvErrorsFile {
  data: any;
  filename: string;
  type: string;
}

export const useEditionCsvEnrollment = (editionId: number | string) => {
  const uploadUrl = ServicesURL.postEditionEnrollCsv.replace(
    ":editionId",
    String(editionId),
  );

  const { trigger: triggerUpload, isMutating } = useSWRMutation(
    uploadUrl,
    (url: string, { arg }: { arg: FormData }) => uploadFile(url, arg),
  );

  const uploadCsv = async (file: File): Promise<EditionCsvUploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    const res: any = await triggerUpload(formData);
    return res?.data ?? res ?? {};
  };

  const downloadTemplate = () =>
    downloadFile(ServicesURL.getEditionEnrollCsvTemplate);

  const fetchErrorsCsv = async (
    uploadBatchId: string,
  ): Promise<EditionCsvErrorsFile> => {
    const url = ServicesURL.getEditionEnrollCsvErrors.replace(
      ":uploadBatchId",
      String(uploadBatchId),
    );
    const res = await axiosInstance.get(url, { responseType: "blob" });
    const dispositionHeader = res.headers["content-disposition"];
    const disposition =
      typeof dispositionHeader === "string" ? dispositionHeader : "";
    const filename =
      disposition.split("filename=")[1]?.replace(/["']/g, "").trim() ||
      "csv-errors.csv";
    const contentTypeHeader = res.headers["content-type"];
    const type =
      typeof contentTypeHeader === "string" ? contentTypeHeader : "text/csv";
    return { data: res.data, filename, type };
  };

  return {
    uploadCsv,
    downloadTemplate,
    fetchErrorsCsv,
    isUploading: isMutating,
  };
};
